import React from 'react';

const Info = (props) => {
  return null;
}

export default Info;